// extracted by mini-css-extract-plugin
export default {"approvalIndicator":"ApprovalIndicator_approvalIndicator__KpJ3i"};